import { Get, Post } from './http.svc'

export const getSwmsAssignments = (params = {}) => {
    const qs = new URLSearchParams()
    if (params.status) qs.set('status', params.status)
    if (params.site) qs.set('site', params.site)
    if (params.swmsStore) qs.set('swmsStore', params.swmsStore)
    const query = qs.toString()
    return Get(`swms/assignments${query ? `?${query}` : ''}`)
}

export const createSwmsAssignment = (data) => Post('swms/assignments', data)

export const archiveSwmsAssignment = (id) => Post(`swms/assignments/${id}/archive`)

export const getAssignmentPdfUrl = (id, type = 'signed') =>
    Get(`swms/assignments/${id}/pdf-url?type=${type}`)
